import React, { useState } from "react";
import "../styles/changePassword.css";
import { updatedPasswordAction } from "../redux/slices/userSlices";
import { useDispatch } from "react-redux";
import Message from "./Message";
// npm i before running this file.
const ChangePassword = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordsMatch, setPasswordsMatch] = useState(true);
  const dispatch = useDispatch();
  const handleOldPasswordChange = (e) => setOldPassword(e.target.value);
  const handleNewPasswordChange = (e) => setNewPassword(e.target.value);
  const handleConfirmPasswordChange = (e) => {
    const newConfirmPassword = e.target.value;
    setConfirmPassword(newConfirmPassword);
    // Check if new password and confirm password match only after confirm password input is filled
    if (newConfirmPassword) {
      setPasswordsMatch(newPassword === newConfirmPassword);
    }
  };

  const changePass = () => {
    const data = {
      oldPassword: oldPassword,
      newPassword: newPassword,
    };

    dispatch(updatedPasswordAction(data));
  };

  return (
    <>
    <Message/>
    <div className="profile-container">
      <div className="profile-box">
        <div className="right-side">
          <h2>Change Password</h2>
          <div className="input-group">
            <label htmlFor="old-password">Old Password:</label>
            <input
              type="password"
              id="old-password"
              value={oldPassword}
              onChange={handleOldPasswordChange}
              placeholder="Enter Old Password"
            />
          </div>
          <div className="input-group">
            <label htmlFor="new-password">New Password:</label>
            <input
              type="password"
              id="new-password"
              value={newPassword}
              onChange={handleNewPasswordChange}
              placeholder="Enter New Password"
            />
          </div>
          <div className="input-group">
            <label htmlFor="confirm-password">Confirm New Password:</label>
            <input
              type="password"
              id="confirm-password"
              value={confirmPassword}
              onChange={handleConfirmPasswordChange}
              placeholder="Confirm New Password"
            />
            {confirmPassword && !passwordsMatch && (
              <p className="error-message">Passwords do not match!</p>
            )}
          </div>

          <div className="buttons">
            <button
              className="save-btn"
              onClick={changePass}
              disabled={!passwordsMatch}
            >
              Change Password
            </button>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default ChangePassword;
